import React, { useState, useEffect } from "react";
import { Card, Descriptions, Divider, PageHeader } from "antd";
import _ from "lodash";
import moment from "moment";
import { ImageViewOnly } from "../../image/onlyImageVIew";
// import { ImageViewer } from "react-image-viewer-dv";

export const ViewFormModel = (props) => {
  const [basicInfo, setbasicInfor] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [id, setId] = useState();

  const openImageModal = (img, id) => {
    setImageOpen(true);
    setSelectedImage(img);
    setId(id);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
  };
  useEffect(
    (res) => {
      const { spotservellience } = props.dataStates;
      if (spotservellience && spotservellience.length) {
        let tempbasic = {
          ...spotservellience[0],
        };
        setbasicInfor([tempbasic]);
      }
    },
    [props.dataStates]
  );

  const getSpotName = (id) => {
    const spotName = props.spotType;
    if (spotName && spotName.length) {
      return (
        _.filter(spotName, function (o) {
          return o.id == id;
        })[0] &&
        _.filter(spotName, function (o) {
          return o.id == id;
        })[0].name
      );
    }
  };

  return (
    <div>
      <PageHeader
        ghost={false}
        onBack={false}
        title="QR Information"
        subTitle="QR Information"
      >
        <Descriptions size="small" column={1}>
          <Descriptions.Item>
            {basicInfo && basicInfo.length
              ? basicInfo[0].qr_code && (
                  <Card
                    hoverable
                    style={{ border: "none" }}
                    // cover={<ImageViewer><img alt="example" src={`${basicInfo && basicInfo[0].qr_code}`} /></ImageViewer>}
                    cover={
                      <img
                        alt="example"
                        src={`${basicInfo && basicInfo[0].qr_code}`}
                        onClick={() =>
                          openImageModal(
                            basicInfo && basicInfo[0].qr_code,
                            basicInfo && basicInfo[0]?.id
                          )
                        }
                      />
                    }
                  ></Card>
                )
              : null}
          </Descriptions.Item>
        </Descriptions>
        {basicInfo && basicInfo.length ? (
          <>
            <Descriptions size="small" column={3}>
              <Descriptions.Item style={{ fontWight: "bold" }} label="Spot नाव">
                <div style={{ fontWeight: "bold", fontSize: 16 }}>
                  {basicInfo && basicInfo[0].qr_name}
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="Spot Type">
                {getSpotName(basicInfo && basicInfo[0].spot_type_id)}
              </Descriptions.Item>
              <Descriptions.Item label="Landmark">
                {basicInfo && basicInfo[0].landmark}
              </Descriptions.Item>

              {/* <Descriptions.Item label="राज्य">
                {getStateName(basicInfo && basicInfo[0].state)}
              </Descriptions.Item>
              <Descriptions.Item label="घटक">
                {getCityName(basicInfo && basicInfo[0].city)}
              </Descriptions.Item> */}
              <Descriptions.Item label="पोलीस ठाणे">
                {basicInfo && basicInfo[0].districtName}
              </Descriptions.Item>
              <Descriptions.Item label="Tagged Location">
                {basicInfo && basicInfo[0].is_geotagged === "1"
                  ? "Tagged"
                  : "Not tagged yet"}
              </Descriptions.Item>
            </Descriptions>
          </>
        ) : null}
        {imageOpen && (
          <ImageViewOnly
            imageOpen={imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              selectedImage
            }
            onClose={closeImageModal}
            id={id}
          />
        )}
      </PageHeader>
    </div>
  );
};
